import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {SendTextDialogController} from '../SendTextDialog.controller';

@observer
export class SendTextDialogContent extends TechseeBaseComponent<{ctrl: SendTextDialogController}> {
    private handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        this.props.ctrl.setText(e.target.value);
    };

    renderInternal(): JSX.Element {
        const {ctrl} = this.props;
        return (
            <div className='sub-modal-body'>
                <textarea
                    className='form-control'
                    value={ctrl.text}
                    onChange={this.handleTextareaChange}
                    rows={5}
                    readOnly={ctrl.isReadonly}
                />
                <h6 className='text-info'>({ctrl.translate('SEND_TEXT.VIEW.COMMENT')})</h6>
            </div>
        );
    }
}
